import { CircularProgress, MenuItem, Select } from '@mui/material';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { ENVIOS_API } from '../../../../../shared/services/envios';

const UpdateEstadoForm = ({ envioId, currentEstado, updateReduxState, handleCloseUpdateState }) => {
    const { dashboardTab } = useSelector((state) => state.envios);
    const [newState, setNewState] = useState(currentEstado);
    const [isLoading, setIsLoading] = useState(false);

    const updateEstado = async () => {
        if (isLoading) return;
        try {
            setIsLoading(true);
            if (
                currentEstado === newState ||
                currentEstado === parseInt(newState)
            ) {
                handleCloseUpdateState();
                return toast.success('Estado actualizado!');
            }

            const data = {
                id: envioId,
                estado_envio_id: newState,
                fecha_estado_envio: new Date()
            }

            const res = await ENVIOS_API.update(data);

            if (res?.success) {
                toast.success('Estado actualizado!')
                handleCloseUpdateState();
                return updateReduxState(data, parseInt(newState));
            }
        } catch (error) {
            return toast.error(error.message);
        } finally {
            setIsLoading(false);
        }
    };
    return (
        <div className='update-estado-form'>
            <Select
                size="small"
                name="searchBy"
                onChange={(e) => setNewState(e.target.value)}
                value={newState}
                className='update-estado-form__select'
            >
                {dashboardTab?.shipping_states?.map(({ estado_id, nombre }) => (
                    <MenuItem key={estado_id} value={estado_id}>
                        {nombre}
                    </MenuItem>
                ))}
            </Select>
            <button onClick={updateEstado} className="btn btn-primary mt-2">
                {isLoading ? (
                    <CircularProgress color="inherit" size={23} />
                ) : (
                    'Actualizar'
                )}
            </button>
        </div>
    );
};

export default UpdateEstadoForm;
